import ApplicationForm from "../components/ApplicationForm";
export default function RegistrationPage() { return <ApplicationForm formType="registration" />; }
